import { render } from "./InvoiceUpdate.vue?vue&type=template&id=50d5745a&scoped=true"
import script from "./InvoiceUpdate.vue?vue&type=script&lang=js"
export * from "./InvoiceUpdate.vue?vue&type=script&lang=js"

import "./InvoiceUpdate.vue?vue&type=style&index=0&id=50d5745a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d5745a"]])

export default __exports__